import { PageStatus, ValidationErrorData } from '../../typings/common';
import { VideoCreatorVideoResource, VideoCreatorVideoResources } from '../api/typings';
import { VideoCreatorTemplate } from '../VideoCreatorHelper/typings';

export const GET_VIDEO_CREATOR_DATA_FOR_EDIT = 'GET_VIDEO_CREATOR_DATA_FOR_EDIT';
export type GET_VIDEO_CREATOR_DATA_FOR_EDIT = typeof GET_VIDEO_CREATOR_DATA_FOR_EDIT;

export interface GetVideoCreatorDataForEditAction {
    type: GET_VIDEO_CREATOR_DATA_FOR_EDIT;
}

export function getVideoCreatorDataForEdit(): GetVideoCreatorDataForEditAction {
    return {
        type: GET_VIDEO_CREATOR_DATA_FOR_EDIT
    };
}

export const UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT = 'UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT';
export type UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT = typeof UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT;

export interface UpdateVideoCreatorDataForEditAction {
    type: UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT;
    template: VideoCreatorTemplate;
    videoResources: VideoCreatorVideoResources;
}

export function updateVideoCreatorDataForEdit(
    template: VideoCreatorTemplate,
    videoResources: VideoCreatorVideoResources
): UpdateVideoCreatorDataForEditAction {
    return {
        type: UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT,
        template,
        videoResources
    };
}

export const UPDATE_VIDEO_CREATOR_PARAM = 'UPDATE_VIDEO_CREATOR_PARAM';
export type UPDATE_VIDEO_CREATOR_PARAM = typeof UPDATE_VIDEO_CREATOR_PARAM;

export interface UpdateVideoCreatorParamAction {
    type: UPDATE_VIDEO_CREATOR_PARAM;
    id: string;
    param: VideoCreatorVideoResource;
}

export function updateVideoCreatorParam(id: string, param: VideoCreatorVideoResource): UpdateVideoCreatorParamAction {
    return {
        type: UPDATE_VIDEO_CREATOR_PARAM,
        id,
        param
    };
}

export const UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS = 'UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS';
export type UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS = typeof UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS;

export interface UpdateVideoCreatorPlayerOptionsAction {
    type: UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS;
    options: {
        startTime: number;
        paused: boolean;
    };
}

export function updateVideoCreatorPlayerOptions(options: {
    startTime: number;
    paused: boolean;
}): UpdateVideoCreatorPlayerOptionsAction {
    return {
        type: UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS,
        options
    };
}

export const SAVE_VIDEO_NAME_EDITOR_CHANGES = 'SAVE_VIDEO_NAME_EDITOR_CHANGES';
export type SAVE_VIDEO_NAME_EDITOR_CHANGES = typeof SAVE_VIDEO_NAME_EDITOR_CHANGES;

export interface SaveVideoNameEditorChangesAction {
    type: SAVE_VIDEO_NAME_EDITOR_CHANGES;
}

export function saveVideoNameEditorChanges(): SaveVideoNameEditorChangesAction {
    return {
        type: SAVE_VIDEO_NAME_EDITOR_CHANGES
    };
}

export const CHANGE_VIDEO_CREATOR_VIDEO_NAME = 'CHANGE_VIDEO_CREATOR_VIDEO_NAME';
export type CHANGE_VIDEO_CREATOR_VIDEO_NAME = typeof CHANGE_VIDEO_CREATOR_VIDEO_NAME;

export interface ChangeVideoCreatorVideoNameAction {
    type: CHANGE_VIDEO_CREATOR_VIDEO_NAME;
    name: string;
}

export function changeVideoCreatorVideoName(name: string): ChangeVideoCreatorVideoNameAction {
    return {
        type: CHANGE_VIDEO_CREATOR_VIDEO_NAME,
        name
    };
}

export const SAVE_VIDEO_FROM_VIDEO_CREATOR = 'SAVE_VIDEO_FROM_VIDEO_CREATOR';
export type SAVE_VIDEO_FROM_VIDEO_CREATOR = typeof SAVE_VIDEO_FROM_VIDEO_CREATOR;

export interface SaveVideoFromVideoCreatorAction {
    type: SAVE_VIDEO_FROM_VIDEO_CREATOR;
}

export function saveVideoFromVideoCreator(): SaveVideoFromVideoCreatorAction {
    return {
        type: SAVE_VIDEO_FROM_VIDEO_CREATOR
    };
}

export const LEAVE_VIDEO_CREATOR_EDIT = 'LEAVE_VIDEO_CREATOR_EDIT';
export type LEAVE_VIDEO_CREATOR_EDIT = typeof LEAVE_VIDEO_CREATOR_EDIT;

export interface LeaveVideoCreatorEditAction {
    type: LEAVE_VIDEO_CREATOR_EDIT;
}

export function leaveVideoCreatorEdit(): LeaveVideoCreatorEditAction {
    return {
        type: LEAVE_VIDEO_CREATOR_EDIT
    };
}

export const CHANGE_VIDEO_CREATOR_IMAGE = 'CHANGE_VIDEO_CREATOR_IMAGE';
export type CHANGE_VIDEO_CREATOR_IMAGE = typeof CHANGE_VIDEO_CREATOR_IMAGE;

export interface ChangeVideoCreatorImageAction {
    type: CHANGE_VIDEO_CREATOR_IMAGE;
    backgroundImage: string;
    paramsId: string;
}

export function changeVideoCreatorImage(backgroundImage: string, paramsId: string): ChangeVideoCreatorImageAction {
    return {
        type: CHANGE_VIDEO_CREATOR_IMAGE,
        backgroundImage,
        paramsId
    };
}

export const SHOW_VIDEO_CREATOR_PARAMS_ERRORS = 'SHOW_VIDEO_CREATOR_PARAMS_ERRORS';
export type SHOW_VIDEO_CREATOR_PARAMS_ERRORS = typeof SHOW_VIDEO_CREATOR_PARAMS_ERRORS;

export interface ShowVideoCreatorParamsErrorsAction {
    type: SHOW_VIDEO_CREATOR_PARAMS_ERRORS;
    errors: ValidationErrorData[];
}

export function showVideoCreatorParamsErrors(errors: ValidationErrorData[]) {
    return {
        type: SHOW_VIDEO_CREATOR_PARAMS_ERRORS,
        errors
    };
}

export const CHANGE_VIDEO_CREATOR_PAGE_STATUS = 'CHANGE_VIDEO_CREATOR_PAGE_STATUS';
export type CHANGE_VIDEO_CREATOR_PAGE_STATUS = typeof CHANGE_VIDEO_CREATOR_PAGE_STATUS;

export interface ChangeVideoCreatorPageStatusAction {
    type: CHANGE_VIDEO_CREATOR_PAGE_STATUS;
    pageStatus: PageStatus;
}

export function changeVideoCreatorPageStatus(pageStatus: PageStatus) {
    return {
        type: CHANGE_VIDEO_CREATOR_PAGE_STATUS,
        pageStatus
    };
}

export type VideoCreatorEditAction =
    | GetVideoCreatorDataForEditAction
    | UpdateVideoCreatorDataForEditAction
    | UpdateVideoCreatorParamAction
    | UpdateVideoCreatorPlayerOptionsAction
    | SaveVideoFromVideoCreatorAction
    | LeaveVideoCreatorEditAction
    | SaveVideoNameEditorChangesAction
    | ChangeVideoCreatorImageAction
    | ChangeVideoCreatorVideoNameAction
    | ShowVideoCreatorParamsErrorsAction
    | ChangeVideoCreatorPageStatusAction;
